import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=6c0fa17d&scoped=true&lang=pug&"
import script from "./AppMenu.vue?vue&type=script&lang=ts&"
export * from "./AppMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AppMenu.vue?vue&type=style&index=0&id=6c0fa17d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0fa17d",
  null
  
)

export default component.exports